export default {
  displayI18nText(i18nLocale, obj) {
    if (!obj) {
      return "";
    }  
    return obj[i18nLocale] || obj["en"];
  },
  displayMultipleItems(items) {
    let combineItems = "";
    if (items.length === 1) {
      combineItems = items[0];
    } else if (items.length === 2) {
      combineItems = `${items[0]} and ${items[1]}`;
    } else if (items.length >= 3) {
      items.forEach((item, index) => {
        if (index !== items.length - 1) {
          combineItems += `${item}, `;
        } else {
          combineItems += `and ${item}`;
        }
      });
    }
    return combineItems;
  }
}